export enum SearchResultType {
  FreeText,
  Standard,
  Details,
  Aggregated,
  License,
  Impersonate
}
